import { Container } from "@material-ui/core"
import { navigate } from "gatsby"
import React, { useEffect, useState } from "react"
import styled from "styled-components"
import $ from "jquery"
import { Layout } from "../components/layout"
import RoundTick from "../assets/forms/round-tick.svg"
import RoundCross from "../assets/forms/round-cross.svg"
import { ApiUrl } from "../util/apiUrl"
import { encode } from "js-base64"
import { makeApiCall } from "../services/apiCall"
import { GFWSpinner } from "../components/spinner/spinner"
import { setUser } from "../services/auth"

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export function validatePassword(password) {
  const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
  return re.test(String(password).toLowerCase())
}

const register = ({ data, location }) => {
  const [firstMount, setFirstMount] = useState(false)
  const [checkEmail, setCheckEmail] = useState({ loading: false, isFree: false })
  const [submitting, setSubmitting] = useState(false)
  const [successMessage, setSuccessMessage] = useState("")

  function isEmailTaken(email) {
    setCheckEmail({ loading: true, isFree: false })
    return makeApiCall("/check-email-exists", { email }).then(res => {
      setCheckEmail({ loading: false, isFree: res.success })
    })
  }

  const [editUsername, setEditUsername] = useState(false)
  const [passwordValiation, setPasswordValidation] = useState({
    length: false,
    UpperLower: false,
    number: false,
    matching: false,
  })

  const [state, setState] = useState({
    title: "",
    firstName: "",
    surname: "",
    emailAddress: "",
    address1: "",
    address2: "",
    address3: "",
    townCity: "",
    postcode: "",
    wouldLikeToRecieveEmailCommunications: null,
    areYou: "",
    jobTitle: "",
    website: "",
    interestedInInvolement: null,
    whyAttending: null,
    university: "",
    courseOfStudy: "",
    courseOfTeaching: "",
    gfwAlumni: null,
    interestedInGaining: null,
    followInstgram: null,
    graduationYear: "",
    othersWhyAttending: null,
    password: "",
    confirmPassword: "",
    company: "",
    workphone: "",
  })
  const [errorState, setErrorState] = useState({
    title: "",
    firstName: "",
    surname: "",
    emailAddress: "",
    address1: "",
    address2: "",
    address3: "",
    townCity: "",
    postcode: "",
    wouldLikeToRecieveEmailCommunications: "",
    areYou: "",
    jobTitle: "",
    website: "",
    interestedInInvolement: "",
    whyAttending: "",
    university: "",
    courseOfStudy: "",
    gfwAlumni: "",
    interestedInGaining: "",
    followInstgram: "",
    graduationYear: "",
    courseOfTeaching: "",
    othersWhyAttending: "",
    password: "",
    confirmPassword: "",
    company: "",
    workphone: "",
  })

  const handleChange = e => {
    setState({ ...state, [e.target.name]: e.target.value })
  }
  const handlePasswordValidiation = e => {
    const { value, name } = e.target

    setState({ ...state, [e.target.name]: e.target.value })

    let validation = passwordValiation
    if (name === "password") {
      if (value.length >= 8) {
        validation = { ...validation, length: true }
      } else {
        validation = { ...validation, length: false }
      }
      if (value.search(/[a-z]/) >= 0 && value.search(/[A-Z]/) >= 0) {
        validation = { ...validation, UpperLower: true }
      } else {
        validation = { ...validation, UpperLower: false }
      }

      if (value.search(/[0-9]/) >= 0) {
        validation = { ...validation, number: true }
      } else {
        validation = { ...validation, number: false }
      }
      if (value === state.confirmPassword) {
        validation = { ...validation, matching: true }
      } else {
        validation = { ...validation, matching: false }
      }
    }
    if (name === "confirmPassword") {
      if (value === state.password) {
        validation = { ...validation, matching: true }
      } else {
        validation = { ...validation, matching: false }
      }
    }

    setPasswordValidation(validation)
  }
  const getValidationClass = name => {
    if (errorState[name] === "pass") {
      return "validation-success"
    } else if (errorState[name] === "") {
      return ""
    } else {
      return "validation-error"
    }
  }
  const inlineValidation = e => {
    const { value, name } = e.target
    let errorMessage = ""

    switch (name) {
      case "firstName":
        if (value === "") {
          errorMessage = "Please enter your first name."
          setErrorState({ ...errorState, [name]: errorMessage })
        } else {
          setErrorState({ ...errorState, [name]: "pass" })
        }
        break
      case "surname":
        if (value === "") {
          errorMessage = "Please enter your surname."
          setErrorState({ ...errorState, [name]: errorMessage })
        } else {
          setErrorState({ ...errorState, [name]: "pass" })
        }
        break
      case "emailAddress":
        if (!validateEmail(value)) {
          errorMessage = "Please enter a valid email address"
          setErrorState({ ...errorState, [name]: errorMessage })
          break
        }
        if (!checkEmail.isFree) {
          errorMessage = "This email is taken. Please choose another."
          setErrorState({ ...errorState, [name]: errorMessage })
          break
        } else {
          setErrorState({ ...errorState, [name]: "pass" })
        }
        break
      case "jobTitle":
        if (value === "") {
          errorMessage = "Please enter your job title."
          setErrorState({ ...errorState, [name]: errorMessage })
        } else {
          setErrorState({ ...errorState, [name]: "pass" })
        }
        break
      case "website":
        if (value === "") {
          errorMessage = "Please enter your website."
          setErrorState({ ...errorState, [name]: errorMessage })
        } else {
          setErrorState({ ...errorState, [name]: "pass" })
        }
        break
      case "university":
        if (value === "") {
          errorMessage = "Please enter your university."
          setErrorState({ ...errorState, [name]: errorMessage })
        } else {
          setErrorState({ ...errorState, [name]: "pass" })
        }
        break
      case "courseOfStudy":
        if (value === "") {
          errorMessage = "Please enter your course title."
          setErrorState({ ...errorState, [name]: errorMessage })
        } else {
          setErrorState({ ...errorState, [name]: "pass" })
        }
        break
      case "graduationYear":
        if (value === "") {
          errorMessage = "Please enter your graduation year."
          setErrorState({ ...errorState, [name]: errorMessage })
        } else {
          setErrorState({ ...errorState, [name]: "pass" })
        }
        break

      default:
        break
    }
  }

  useEffect(() => {
    if (firstMount) {
      const pseduoEvent = {
        target: {
          value: state.emailAddress,
          name: "emailAddress",
        },
      }
      inlineValidation(pseduoEvent)
    }
    setFirstMount(true)
  }, [checkEmail])
  const titleArray = ["Mr", "Mrs", "Miss", "Ms"]
  const titleRadioButtons = titleArray.map((title, i) => (
    <>
      <input
        type={"radio"}
        id={"title-rad-" + i}
        name={"title"}
        value={title}
        onChange={e => {
          setState({ ...state, title: e.target.value })
        }}
      />
      <label htmlFor={"title-rad-" + i}>{title}</label>
    </>
  ))

  const areYouArray = [
    "Industry / Media",
    "Class of 2021 Graduate at a member university",
    "Undergraduate Student at a member university",
    "University Staff",
    "All others",
  ]

  const areYouRadioButtons = areYouArray.map((title, i) => (
    <>
      <input
        type={"radio"}
        id={"are-you-rad-" + i}
        name={"areYou"}
        value={title}
        onChange={e => {
          setState({ ...state, areYou: e.target.value })
        }}
      />
      <label htmlFor={"are-you-rad-" + i}>{title}</label>
    </>
  ))

  const whyAttendingArray = [
    "Scouting talent",
    "Interested in the work of GFF",
    "Looking for potential employees ",
    "Making new connections",
    "Networking",
  ]

  const whyAttendingRadioButtons = whyAttendingArray.map((title, i) => (
    <>
      <input
        type={"radio"}
        id={"why-attending-rad-" + i}
        name={"whyAttending"}
        value={title}
        onChange={e => {
          setState({ ...state, whyAttending: title })
        }}
      />
      <label htmlFor={"why-attending-rad-" + i}>{title}</label>
    </>
  ))

  const interestedInGainingArray = [
    "Job Opportunities",
    "Networking Opportunities",
    "Careers Advice",
    "Meeting and Collaborating With Other Graduates",
    "Listening to GFW Live Talks",
    "Internship and Placement Opportunities",
    "Building Your Contacts",
    "Other",
  ]

  const interestedInGainingRadioButtons = interestedInGainingArray.map((title, i) => (
    <>
      <input
        type={"radio"}
        id={"why-attending-rad-" + i}
        name={"interestedInGaining"}
        value={title}
        onChange={e => {
          setState({ ...state, interestedInGaining: title })
        }}
      />
      <label htmlFor={"why-attending-rad-" + i}>{title}</label>
    </>
  ))

  const othersWhyAttendingArray = [
    "Friend/family member exhibiting at event",
    "Interested in fashion",
    "Thinking about studying fashion at University",
    "Looking for work in the fashion industry",
    "Looking for potential employees",
    "Attend a GFW Live talk",
    "Other",
  ]

  const othersWhyAttendingRadioButtons = othersWhyAttendingArray.map((title, i) => (
    <>
      <input
        type={"radio"}
        id={"others-why-attending-rad-" + i}
        name={"othersWhyAttending"}
        value={title}
        onChange={e => {
          setState({ ...state, othersWhyAttending: title })
        }}
      />
      <label htmlFor={"others-why-attending-rad-" + i}>{title}</label>
    </>
  ))
  const handleSubmit = e => {
    setSubmitting(true)
    setErrorState({
      title: "",
      firstName: "",
      surname: "",
      emailAddress: "",
      address1: "",
      address2: "",
      address3: "",
      townCity: "",
      postcode: "",
      wouldLikeToRecieveEmailCommunications: "",
      areYou: "",
      jobTitle: "",
      website: "",
      interestedInInvolement: "",
      whyAttending: "",
      university: "",
      courseOfStudy: "",
      gfwAlumni: "",
      interestedInGaining: "",
      followInstgram: "",
      graduationYear: "",
      courseOfTeaching: "",
      othersWhyAttending: "",
      password: "",
      confirmPassword: "",
      company: "",
      workphone: "",
    })
    e.preventDefault()
    if (state.title === "") {
      setErrorState({
        ...errorState,
        title: "Please select your title option.",
      })
      const elements = $("#title")
      elements[0].scrollIntoView()
      return
    }
    if (state.firstName === "") {
      setErrorState({
        ...errorState,
        firstName: "Please enter your first name.",
      })
      const elements = $("#firstName")
      elements[0].scrollIntoView()
      return
    }
    if (state.surname === "") {
      setErrorState({ ...errorState, surname: "Please enter your surname." })
      const elements = $("#surname")
      elements[0].scrollIntoView()
      return
    }
    if (state.emailAddress === "") {
      setErrorState({
        ...errorState,
        emailAddress: "Please enter your email address.",
      })
      const elements = $("#email")
      elements[0].scrollIntoView()
      return
    }
    if (!validateEmail(state.emailAddress)) {
      setErrorState({
        ...errorState,
        emailAddress: "Please enter a valid email address.",
      })
      const elements = $("#email")
      elements[0].scrollIntoView()
      return
    }
    if (!checkEmail.isFree) {
      setErrorState({ ...errorState, emailAddress: "This email is taken. Please choose another." })
      const elements = $("#email")
      elements[0].scrollIntoView()
      return
    }
    //Check are you, (5 if statements)
    //Validate on the branch
    // BRANCH ONE ========================================================================================
    if (state.areYou === areYouArray[0]) {
      if (state.jobTitle === "") {
        setErrorState({
          ...errorState,
          jobTitle: "Please enter your job title.",
        })
        const elements = $("#jobTitle")
        elements[0].scrollIntoView()
        return
      }
      if (state.company === "") {
        setErrorState({
          ...errorState,
          company: "Please enter your company.",
        })
        const elements = $("#company")
        elements[0].scrollIntoView()
        return
      }
      if (state.interestedInInvolement === null) {
        setErrorState({
          ...errorState,
          interestedInInvolement: "Please select an option.",
        })
        const elements = $("#interestedInInvolement")
        elements[0].scrollIntoView()
        return
      }
      if (state.whyAttending === null) {
        setErrorState({
          ...errorState,
          whyAttending: "Please select an option.",
        })
        const elements = $("#whyAttending")
        elements[0].scrollIntoView()
        return
      }
    }
    // BRANCH TWO ========================================================================================
    if (state.areYou === areYouArray[1]) {
      if (state.university === "") {
        setErrorState({
          ...errorState,
          university: "Please enter your university.",
        })
        const elements = $("#university")
        elements[0].scrollIntoView()
        return
      }
      if (state.courseOfStudy === "") {
        setErrorState({
          ...errorState,
          courseOfStudy: "Please enter your course of study.",
        })
        const elements = $("#courseOfStudy")
        elements[0].scrollIntoView()
        return
      }
      if (state.gfwAlumni === null) {
        setErrorState({
          ...errorState,
          gfwAlumni: "Please select an option.",
        })
        const elements = $("#gfwAlumni")
        elements[0].scrollIntoView()
        return
      }
      if (state.interestedInGaining === null) {
        setErrorState({
          ...errorState,
          interestedInGaining: "Please select an option.",
        })
        const elements = $("#interestedInGaining")
        elements[0].scrollIntoView()
        return
      }

      if (state.followInstgram === null) {
        setErrorState({
          ...errorState,
          followInstgram: "Please select an option.",
        })
        const elements = $("#followInstgram")
        elements[0].scrollIntoView()
        return
      }
    }
    // BRANCH THREE ========================================================================================
    if (state.areYou === areYouArray[2]) {
      if (state.university === "") {
        setErrorState({
          ...errorState,
          university: "Please enter your university.",
        })
        const elements = $("#university")
        elements[0].scrollIntoView()
        return
      }
      if (state.courseOfStudy === "") {
        setErrorState({
          ...errorState,
          courseOfStudy: "Please enter your course of study.",
        })
        const elements = $("#courseOfStudy")
        elements[0].scrollIntoView()
        return
      }
      if (state.graduationYear === "") {
        setErrorState({
          ...errorState,
          graduationYear: "Please enter your graduation year.",
        })
        const elements = $("#graduationYear")
        elements[0].scrollIntoView()
        return
      }
    }
    // BRANCH FOUR ========================================================================================
    if (state.areYou === areYouArray[3]) {
      if (state.university === "") {
        setErrorState({
          ...errorState,
          university: "Please enter your university.",
        })
        const elements = $("#university")
        elements[0].scrollIntoView()
        return
      }
      if (state.jobTitle === "") {
        setErrorState({
          ...errorState,
          jobTitle: "Please enter your course of study.",
        })
        const elements = $("#jobTitle")
        elements[0].scrollIntoView()
        return
      }
    }
    // BRANCH five ========================================================================================
    if (state.areYou === areYouArray[4]) {
      if (state.othersWhyAttending === null) {
        setErrorState({
          ...errorState,
          othersWhyAttending: "Please select an option.",
        })
        const elements = $("#othersWhyAttending")
        elements[0].scrollIntoView()
        return
      }
    }
    //send the result
    if (
      !passwordValiation.UpperLower ||
      !passwordValiation.length ||
      !passwordValiation.matching ||
      !passwordValiation.number
    ) {
      setErrorState({
        ...errorState,
        password: "Please resolve the issues with your password.",
      })
      const elements = $("#password")
      elements[0].scrollIntoView()
      return
    }
    const timestamp = +new Date()

    const newUser = {
      ...state,
      password: encode(state.password),
      confirmPassword: encode(state.confirmPassword),
      timestamp: timestamp,
    }

    fetch(`${ApiUrl}/register`, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        Authorization: "Api-Key 18475794-de56-4ff0-a685-3d591fb81661",
      },
      body: JSON.stringify(newUser), // body data type must match "Content-Type" header
    })
      .then(response => {
        return response.json()
      })
      .then(data => {
        setUser(data.user)
        navigate(`/events/account`)
      })
      .catch(e => {
        setSubmitting(false)
      })
  }
  return (
    <Layout title={"Graduate Fashion Week - Register"}>
      <StyledContainer maxWidth={"md"}>
        <h2>REGISTER NOW FOR DIGITAL ACCESS TO GRADUATE FASHION WEEK</h2>
        <BodyText>
          Register your details to gain access to view the live-stream content of runway shows, GFW Live! talks,
          exclusive university video premiers and all digital content for Graduate Fashion Week 2021.
        </BodyText>
        <form onSubmit={handleSubmit}>
          <label id={"title"}>Title</label>

          {titleRadioButtons.map(v => v)}
          <ErrorMessage>{errorState.title}</ErrorMessage>

          <Columns>
            <div>
              <label id={"firstName"}>First Name</label>

              <input
                type={"text"}
                name={"firstName"}
                className={getValidationClass("firstName")}
                value={state.firstName}
                onChange={e => handleChange(e)}
                onBlur={e => inlineValidation(e)}
              ></input>
              <ErrorMessage>{errorState.firstName !== "pass" ? errorState.firstName : " "}</ErrorMessage>
            </div>

            <div>
              <label id={"surname"}>Surname</label>

              <input
                type={"text"}
                name={"surname"}
                className={getValidationClass("surname")}
                value={state.surname}
                onChange={e => handleChange(e)}
                onBlur={e => inlineValidation(e)}
              ></input>
              <ErrorMessage>{errorState.surname !== "pass" ? errorState.surname : " "}</ErrorMessage>
            </div>
          </Columns>

          <label id={"email"}>
            Email address
            {checkEmail.loading ? <GFWSpinner size={10} style={{ marginLeft: 10 }} thickness={5} disableShrink /> : ""}
          </label>

          <input
            type={"email"}
            name={"emailAddress"}
            value={state.emailAddress}
            className={getValidationClass("emailAddress")}
            onChange={e => handleChange(e)}
            onBlur={e => isEmailTaken(e.target.value)}
          ></input>
          <ErrorMessage>
            {errorState.emailAddress !== "pass" && !checkEmail.loading ? errorState.emailAddress : " "}
          </ErrorMessage>

          <br />
          <label>Address (Optional)</label>
          <br />
          <Columns>
            <div>
              <label>Address 1</label>

              <input type={"text"} name={"address1"} value={state.address1} onChange={e => handleChange(e)}></input>
              <ErrorMessage>{errorState.address1}</ErrorMessage>
            </div>
            <div>
              <label>Address 2</label>

              <input type={"text"} name={"address2"} value={state.address2} onChange={e => handleChange(e)}></input>
              <ErrorMessage>{errorState.address2}</ErrorMessage>
            </div>
          </Columns>
          <Columns>
            <div>
              <label>Address 3</label>

              <input type={"text"} name={"address3"} value={state.address3} onChange={e => handleChange(e)}></input>
              <ErrorMessage>{errorState.address3}</ErrorMessage>
            </div>

            <div>
              <label>Town / City</label>

              <input type={"text"} name={"townCity"} value={state.townCity} onChange={e => handleChange(e)}></input>
              <ErrorMessage>{errorState.townCity}</ErrorMessage>
            </div>
          </Columns>

          <Columns>
            <div>
              <label>Postcode</label>

              <input type={"text"} name={"postcode"} value={state.postcode} onChange={e => handleChange(e)}></input>
              <ErrorMessage>{errorState.postcode}</ErrorMessage>
            </div>
            <div></div>
          </Columns>
          <hr />

          <p style={{ fontSize: 18, lineHeight: "28px" }}>
            Graduate Fashion Foundation would like to send you occasional exciting news. To join our mailing list,
            simply tick the box below. You can unsubscribe at any time. We will never share your data and we promise to
            keep your details safe and secure.
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <input
              type={"radio"}
              id={"communications-rad-1"}
              name={"communication"}
              value={"yes"}
              // checked
              onChange={e =>
                setState({
                  ...state,
                  wouldLikeToRecieveEmailCommunications: true,
                })
              }
            />
            <label htmlFor={"communications-rad-1"} style={{ flex: 1 }}>
              I would like to receive communications by email
            </label>
            <input
              type={"radio"}
              id={"communications-rad-2"}
              name={"communication"}
              value={"no"}
              onChange={e =>
                setState({
                  ...state,
                  wouldLikeToRecieveEmailCommunications: false,
                })
              }
            />
            <label htmlFor={"communications-rad-2"} style={{ flex: 1 }}>
              I do not wish to receive communications by email
            </label>
          </div>
          <hr />
          {state.wouldLikeToRecieveEmailCommunications !== null ? (
            <div>
              <label>Are you:</label>

              {areYouRadioButtons.map(v => v)}
            </div>
          ) : null}
          <br />

          {/* PATH 1 ============================================================================= */}
          {state.areYou === areYouArray[0] ? (
            <div>
              <Columns>
                <div>
                  <label id={"jobTitle"}>Job Title</label>

                  <input type={"text"} name={"jobTitle"} value={state.jobTitle} onChange={e => handleChange(e)}></input>
                  <ErrorMessage>{errorState.jobTitle}</ErrorMessage>
                </div>
                <div>
                  <label id={"company"}>Company</label>

                  <input type={"text"} name={"company"} value={state.company} onChange={e => handleChange(e)}></input>
                  <ErrorMessage>{errorState.company}</ErrorMessage>
                </div>
              </Columns>
              <Columns>
                <div>
                  <label id={"workphone"}>Work Phone (Optional)</label>

                  <input
                    type={"text"}
                    name={"workphone"}
                    value={state.workphone}
                    onChange={e => handleChange(e)}
                  ></input>
                  <ErrorMessage>{errorState.workphone}</ErrorMessage>
                </div>
                <div>
                  <label id={"website"}>Website (Optional)</label>

                  <input type={"text"} name={"website"} value={state.website} onChange={e => handleChange(e)}></input>
                  <ErrorMessage>{errorState.website}</ErrorMessage>
                </div>
              </Columns>
              <label id={"interestedInInvolement"}>
                Would you be interested in getting involved with Graduate Fashion Foundation and Graduate Fashion Week?
                This could be with a role Judging, Mentoring, Joining a Panel talk or other ways.
              </label>

              <input
                type={"radio"}
                id={"interestedInInvolement-rad-1"}
                name={"interestedInInvolement"}
                value={"yes"}
                onChange={e =>
                  setState({
                    ...state,
                    interestedInInvolement: true,
                  })
                }
              />

              <label htmlFor={"interestedInInvolement-rad-1"}>
                Yes, I&apos;d like to get involved with GFF and GFW and give permission for them to get in touch.
              </label>

              <input
                type={"radio"}
                id={"interestedInInvolement-rad-2"}
                name={"interestedInInvolement"}
                value={"no"}
                onChange={e =>
                  setState({
                    ...state,
                    interestedInInvolement: false,
                  })
                }
              />
              <label htmlFor={"interestedInInvolement-rad-2"}>
                No, I would not like to get involved with GFF and GFW
              </label>
              <br />
              <ErrorMessage>{errorState.interestedInInvolement}</ErrorMessage>
              <label id={"whyAttending"}>Which best describes why you are attending Graduate Fashion Week?</label>

              {whyAttendingRadioButtons.map(v => v)}
              <ErrorMessage>{errorState.whyAttending}</ErrorMessage>
            </div>
          ) : null}
          {/* PATH 2 ============================================================================= */}
          {state.areYou === areYouArray[1] ? (
            <div>
              <Columns>
                <div>
                  <label id={"university"}>University of Study</label>

                  <input
                    type={"text"}
                    name={"university"}
                    value={state.university}
                    onChange={e => handleChange(e)}
                  ></input>
                  <ErrorMessage>{errorState.university}</ErrorMessage>
                </div>
                <div>
                  <label id={"courseOfStudy"}>Course of Study</label>

                  <input
                    type={"text"}
                    name={"courseOfStudy"}
                    value={state.courseOfStudy}
                    onChange={e => handleChange(e)}
                  ></input>
                  <ErrorMessage>{errorState.courseOfStudy}</ErrorMessage>
                </div>
              </Columns>
              <label id={"gfwAlumni"}>
                Graduate Fashion Foundation would like to add you to the GFF Alumni list to send you exciting news, jobs
                and events. To join the mailing list, simply tick the box below. We will never share your data and we
                promise to keep your details safe and secure.
              </label>
              <br />

              <input
                type={"radio"}
                id={"gfwAlumni-rad-1"}
                name={"gfwAlumni"}
                value={"yes"}
                onChange={e =>
                  setState({
                    ...state,
                    gfwAlumni: true,
                  })
                }
              />
              <label htmlFor={"gfwAlumni-rad-1"}>Yes, I would like to receive communications by email</label>

              <input
                type={"radio"}
                id={"gfwAlumni-rad-2"}
                name={"gfwAlumni"}
                value={"no"}
                onChange={e =>
                  setState({
                    ...state,
                    gfwAlumni: false,
                  })
                }
              />
              <label htmlFor={"gfwAlumni-rad-2"}>No, I do not wish to receive communications by email</label>
              <ErrorMessage>{errorState.gfwAlumni}</ErrorMessage>
              <br />

              <label id={"interestedInGaining"}>
                What are you interested in gaining from attending Graduate Fashion Week this June?
              </label>
              <br />

              {interestedInGainingRadioButtons.map(v => v)}
              <ErrorMessage>{errorState.interestedInGaining}</ErrorMessage>
              <br />

              <label id={"followInstgram"}>Do you follow the @OfficalGFW Instagram channel?</label>
              <br />

              <input
                type={"radio"}
                id={"followInstgram-rad-1"}
                name={"followInstgram"}
                value={"yes"}
                onChange={e =>
                  setState({
                    ...state,
                    followInstgram: true,
                  })
                }
              />
              <label htmlFor={"followInstgram-rad-1"}>Yes</label>

              <input
                type={"radio"}
                id={"followInstgram-rad-2"}
                name={"followInstgram"}
                value={"no"}
                onChange={e =>
                  setState({
                    ...state,
                    followInstgram: false,
                  })
                }
              />
              <label htmlFor={"followInstgram-rad-2"}>No</label>
              <ErrorMessage>{errorState.followInstgram}</ErrorMessage>
              <br />
            </div>
          ) : null}

          {/* PATH 3 ============================================================================= */}
          {state.areYou === areYouArray[2] ? (
            <div>
              <Columns>
                <div>
                  <label id={"university"}>University of Study</label>

                  <input
                    type={"text"}
                    name={"university"}
                    value={state.university}
                    onChange={e => handleChange(e)}
                  ></input>
                  <ErrorMessage>{errorState.university}</ErrorMessage>
                </div>
                <div>
                  <label id={"courseOfStudy"}>Course of Study</label>

                  <input
                    type={"text"}
                    name={"courseOfStudy"}
                    value={state.courseOfStudy}
                    onChange={e => handleChange(e)}
                  ></input>
                  <ErrorMessage>{errorState.courseOfStudy}</ErrorMessage>
                </div>
              </Columns>
              <Columns>
                <div>
                  <label id={"graduationYear"}>Year of Graduation</label>

                  <input
                    type={"text"}
                    name={"graduationYear"}
                    value={state.graduationYear}
                    onChange={e => handleChange(e)}
                  ></input>
                  <ErrorMessage>{errorState.graduationYear}</ErrorMessage>
                </div>
                <div></div>
              </Columns>
            </div>
          ) : null}
          {/* PATH 4 ============================================================================= */}
          {state.areYou === areYouArray[3] ? (
            <div>
              <Columns>
                <div>
                  <label id={"university"}>University</label>

                  <input
                    type={"text"}
                    name={"university"}
                    value={state.university}
                    onChange={e => handleChange(e)}
                  ></input>
                  <ErrorMessage>{errorState.university}</ErrorMessage>
                </div>
                <div>
                  <label id={"jobTitle"}>Job Title</label>

                  <input type={"text"} name={"jobTitle"} value={state.jobTitle} onChange={e => handleChange(e)}></input>
                  <ErrorMessage>{errorState.jobTitle}</ErrorMessage>
                </div>
              </Columns>

              <div>
                <label>Which Course/Subject do you teach? (Optional)</label>

                <input
                  type={"text"}
                  name={"courseOfTeaching"}
                  value={state.courseOfTeaching}
                  onChange={e => handleChange(e)}
                ></input>
                <ErrorMessage>{errorState.courseOfTeaching}</ErrorMessage>
              </div>
            </div>
          ) : null}
          {/* PATH 5 ============================================================================= */}
          {state.areYou === areYouArray[4] ? (
            <div>
              <label id={"othersWhyAttending"}>Which best describes why you are attending Graduate Fashion Week?</label>
              <br />
              {othersWhyAttendingRadioButtons.map(v => v)}
              <ErrorMessage>{errorState.othersWhyAttending}</ErrorMessage>
            </div>
          ) : null}
          {state.areYou !== "" ? (
            <>
              <hr />
              <label>Your account details</label>
              <br />
            </>
          ) : null}
          {state.areYou !== "" && editUsername ? (
            <>
              <label id={"email"}>
                Email address
                {checkEmail.loading ? (
                  <GFWSpinner size={10} style={{ marginLeft: 10 }} thickness={5} disableShrink />
                ) : (
                  ""
                )}
              </label>

              <input
                type={"email"}
                name={"emailAddress"}
                value={state.emailAddress}
                className={getValidationClass("emailAddress")}
                onChange={e => handleChange(e)}
                onBlur={e => isEmailTaken(e.target.value)}
              ></input>
              <ErrorMessage>
                {errorState.emailAddress !== "pass" && !checkEmail.loading ? errorState.emailAddress : " "}
              </ErrorMessage>
            </>
          ) : null}
          {state.areYou !== "" && !editUsername ? (
            <>
              <br />
              <div>
                <label style={{ display: "inline-block" }}>Username: {state.emailAddress}</label>{" "}
                <label style={{ paddingLeft: 30, display: "inline-block" }} onClick={() => setEditUsername(true)}>
                  <a style={{ display: "inline" }}>Edit</a>
                </label>
              </div>
              <br />
            </>
          ) : null}
          {state.areYou !== "" ? (
            <>
              <label id={"password"}>Password</label>

              <input
                type={"password"}
                name={"password"}
                value={state.password}
                onChange={handlePasswordValidiation}
              ></input>
              <br />
              <br />
              <label>Your password must have</label>
              <Columns>
                <PasswordStrength>
                  <p>{passwordValiation.length ? <RoundTickStyled /> : <RoundCrossStyled />}8 or more characters</p>
                  <p>
                    {passwordValiation.number ? <RoundTickStyled /> : <RoundCrossStyled />}
                    At least one number
                  </p>
                </PasswordStrength>
                <PasswordStrength>
                  <p>
                    {passwordValiation.UpperLower ? <RoundTickStyled /> : <RoundCrossStyled />}
                    Upper and lower case letters
                  </p>

                  <p>
                    {passwordValiation.matching ? <RoundTickStyled /> : <RoundCrossStyled />}
                    Must match confirmation
                  </p>
                </PasswordStrength>
                <div></div>
              </Columns>
              <br />

              <label>Confirm Password</label>

              <input
                type={"password"}
                name={"confirmPassword"}
                value={state.confirmPassword}
                onChange={handlePasswordValidiation}
              ></input>
              <ErrorMessage>{errorState.password !== "pass" ? errorState.password : " "}</ErrorMessage>
              <br />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input type="submit" name={"submit"} value={"REGISTER"}></input>
                {submitting ? <GFWSpinner size={10} style={{ marginLeft: 10 }} thickness={5} disableShrink /> : null}
              </div>
            </>
          ) : null}
        </form>
      </StyledContainer>
    </Layout>
  )
}

const PasswordStrength = styled.div`
  > p {
    margin-bottom: 16px;
    padding-bottom: 0px;
    line-height: 16px;
  }
`

const RoundTickStyled = styled(RoundTick)`
  height: 15px;
  width: 15px;
  margin-right: 10px;
  top: 3px;
  position: relative;
  fill: ${props => props.theme.colors.turquoise};
  color: ${props => props.theme.colors.turquoise};
`
const RoundCrossStyled = styled(RoundCross)`
  height: 15px;
  width: 15px;
  margin-right: 10px;
  top: 3px;
  position: relative;
`

const Columns = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  > div {
    flex: 1;
    + div {
      margin-left: 30px;
      @media (max-width: ${props => props.theme.breakpoints.sm}) {
        margin-left: 0px;
      }
    }
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
  }
`

export const ErrorMessage = styled.p`
  color: #d0021b;
  line-height: 14px;
  font-size: 14px;
  margin: 0px !important;
  padding-top: 3px;
  padding-bottom: 3px;
`
const BodyText = styled.p`
  font-size: 22px;
  line-height: 28px;

  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: 16px;
    line-height: 24px;
  }
`

const StyledContainer = styled(Container)`
  padding-top: 120px;
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    padding-top: 40px;
  }
`

export default register
